import { OrderMerchant, ChargebackStatus, Chargeback } from './types'
import { isUndefinedOrEmpty } from '@afterpay/utils'

export const getMerchantName = (merchant?: OrderMerchant): string | undefined => {
  if (typeof merchant === 'undefined') {
    return
  }

  const merchantDisplayName = merchant.merchantDisplayName
  const merchantName = merchant.name
  const fallbackName = isUndefinedOrEmpty(merchantName) ? undefined : merchantName

  return isUndefinedOrEmpty(merchantDisplayName) ? fallbackName : merchantDisplayName
}

export const isResolvedChargeback = (chargeback?: Chargeback): boolean => {
  const resolvedChargebackStatusList: ChargebackStatus[] = [ChargebackStatus.LOST, ChargebackStatus.WIN]
  return typeof chargeback !== 'undefined' && resolvedChargebackStatusList.includes(chargeback.status)
}
